export const REPORTS_TABLE_UNIQUE_ID = 'scheduling-project-reports';

export const REPORTS_TABLE_ROW_HEIGHT = 48;

/**
 * Initial width of every column of the Scheduling Project reports table, keyed by the same
 * `col-*` class the header and row cells in scheduling-project-reports-table.html carry.
 *
 * `col-name` is not a free choice: TableColumnManager pins that exact class to the left edge,
 * which is what keeps the Name column visible while the table scrolls sideways.
 *
 * Keep in sync with _reports-table-columns.scss - the SCSS map lays the columns out on first
 * paint, this map is what the resize engine falls back to for a column the user never resized.
 */
export const REPORTS_TABLE_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-name': 260,
  'col-template': 180,
  'col-status': 120,
  'col-branch-group': 170,
  'col-branches': 150,
  'col-total-jobs': 110,
  'col-total-routes': 120,
  'col-published-routes': 140,
  'col-dispatched-routes': 150,
  'col-created-by': 160,
  'col-role': 130
};
